import { Mapper } from "../../../../base/utils/mapper";
import { TypeAvailableDocumentModel } from "../../../../domain/models/consult/type-available-document.model";
import { TypeAvailableDocumentEntity } from "../entities/type-available-document.entity";


export class TypeAvailableDocumentImplementationRepositoryMapper extends Mapper<TypeAvailableDocumentEntity, TypeAvailableDocumentModel> {
    mapFrom(param: TypeAvailableDocumentEntity): TypeAvailableDocumentModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeAvailableDocumentModel): TypeAvailableDocumentEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}